module.exports = __webpack_public_path__ + "static/img/special-offers-img@m.5e26028.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/haevichi/special-offers-img@m.png
// module id = 6uOE
// module chunks = 0